import { render, staticRenderFns } from "./Navs.vue?vue&type=template&id=3d12136d&"
import script from "./Navs.vue?vue&type=script&lang=js&"
export * from "./Navs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports